import { render } from "./pattern-insights-index.vue?vue&type=template&id=2de3779e"
import script from "./pattern-insights-index.vue?vue&type=script&lang=js"
export * from "./pattern-insights-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__